import { render, staticRenderFns } from "./ShopCard.vue?vue&type=template&id=233117a9&"
import script from "./ShopCard.vue?vue&type=script&lang=js&"
export * from "./ShopCard.vue?vue&type=script&lang=js&"
import style0 from "./ShopCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports